module.exports = __webpack_public_path__ + "img/VIP.e2c606b5.png";